module.exports = __webpack_public_path__ + "img/toolsItem03.6b017807.png";